import { render, staticRenderFns } from "./langtest.vue?vue&type=template&id=3bcd6521&scoped=true&"
import script from "./langtest.vue?vue&type=script&lang=js&"
export * from "./langtest.vue?vue&type=script&lang=js&"
import style0 from "./langtest.vue?vue&type=style&index=0&id=3bcd6521&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd6521",
  null
  
)

export default component.exports